<template>
    <van-popup v-model="visible" round position="bottom" @close="resetForm">
        <div class="bind-phone-header">修改密码</div>
        <van-form ref="form" :key="formKey" @submit="onSubmit">
            <van-field
                v-model="form.old_password"
                type="password"
                name="旧密码"
                label="旧密码"
                placeholder="请输入旧密码"
                :rules="oldpasswordRules"
            />
            <van-field
                v-model="form.password"
                type="password"
                name="新密码"
                label="新密码"
                placeholder="请输入新密码"
                :rules="passwordRules"
            />
            <van-field
                v-model="form.password_confirm"
                type="password"
                label="确认密码"
                placeholder="请输入确认密码"
                :rules="confirmRules"
            >
            </van-field>
            <div style="margin: 16px">
                <van-row gutter="16">
                    <van-col span="12">
                        <van-button round block type="info" @click="resetForm">取消</van-button>
                    </van-col>
                    <van-col span="12">
                        <van-button round block type="info" native-type="submit">确定</van-button>
                    </van-col>
                </van-row>
            </div>
        </van-form>
    </van-popup>
</template>

<script>
import { setLoginPassword } from '@/api/user'

export default {
    name: 'ChangeLoginPassword',
    data() {
        return {
            visible: false,
            form: {
                old_password: '',
                password: '',
                password_confirm: '',
            },
            oldpasswordRules: [
                { required: true, message: '请输入旧密码', trigger: 'onBlur' },
                { pattern: /\s*\S+?/, message: '请输入非空字符', trigger: 'onBlur' },
            ],
            passwordRules: [
                { required: true, message: '请输入新密码', trigger: 'onBlur' },
                { pattern: /\s*\S+?/, message: '请输入非空字符', trigger: 'onBlur' },
                { pattern: /^.{4,20}$/, message: '密码不少于4个字符', trigger: 'onBlur' },
            ],
            confirmRules: [
                { required: true, message: '请输入确认密码', trigger: 'onBlur' },
                { pattern: /\s*\S+?/, message: '请输入非空字符', trigger: 'onBlur' },
                { pattern: /^.{4,20}$/, message: '密码不少于4个字符', trigger: 'onBlur' },
                {
                    validator: (val) => {
                        return this.form.password === val
                    },
                    message: '两次密码不一致',
                },
            ],
            formKey: 0,
        }
    },
    methods: {
        show() {
            this.visible = true
        },
        onSubmit() {
            this.$refs.form.validate().then(() => {
                setLoginPassword(this.form)
                    .then((res) => {
                        this.$toast.success(res.message)
                    })
                    .catch(() => {
                        this.$toast.fail('提交失败')
                    })
                this.resetForm()
            })
        },
        resetForm() {
            this.visible = false
            this.formKey++ // 手动清除 form 表单校验
            this.$refs.form.resetValidation()
            this.form = {
                old_password: '',
                password: '',
                password_confirm: '',
            }
        },
    },
}
</script>

<style lang="less" scoped>
.bind-phone-header {
    flex-shrink: 0;
    font-weight: 500;
    font-size: @large-font-size;
    line-height: 48px;
    text-align: center;
}
</style>
